export enum SortingDirection {
  ASC = "asc",
  DESC = "desc",
}

export interface SortingItem {
  field: string;
  direction: SortingDirection | null;
}
